import { render, staticRenderFns } from "./yyz.vue?vue&type=template&id=44b5410a&scoped=true&"
import script from "./yyz.vue?vue&type=script&lang=js&"
export * from "./yyz.vue?vue&type=script&lang=js&"
import style0 from "./yyz.vue?vue&type=style&index=0&id=44b5410a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b5410a",
  null
  
)

export default component.exports